<template>
  <div >
    <Line :chart-data="chartData" :chart-options="chartOptions" />
  </div>
</template>

<script>
import { computed } from "vue";
import { Line } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale
);

export default {
  name: "HealthHeartRateChart",
  components: { Line },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const sorted = computed(() =>
      [...(props.items || [])].sort((a, b) =>
        String(a.calendar_date).localeCompare(String(b.calendar_date))
      )
    );

    const chartData = computed(() => ({
      labels: sorted.value.map((e) => e.calendar_date),
      datasets: [
        {
          label: "HR Resting",
          data: sorted.value.map(e => e.hr_resting),
          borderColor: "#EF5350",
          backgroundColor: "rgba(239,83,80,0.2)",
          tension: 0.3,
          yAxisID: "hr",
          borderWidth: 1,
          pointRadius: 0,
        },
        {
          label: "HR Min",
          data: sorted.value.map(e => e.hr_min),
          borderColor: "#42A5F5",
          backgroundColor: "rgba(66,165,245,0.2)",
          tension: 0.3,
          yAxisID: "hr",
          borderWidth: 1,
          pointRadius: 0,
        },
        {
          label: "HR Max",
          data: sorted.value.map(e => e.hr_max),
          borderColor: "#AB47BC",
          backgroundColor: "rgba(171,71,188,0.2)",
          tension: 0.3,
          yAxisID: "hr",
          borderWidth: 1,
          pointRadius: 0,
        },
      ],
    }));

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { position: "top" },
        tooltip: {
          callbacks: {
            label: ctx => `${ctx.dataset.label}: ${ctx.parsed.y} bpm`,
          },
        },
      },
      scales: {
        x: {
          title: { display: true, text: "Date" },
        },
        hr: {
          type: "linear",
          position: "left",
          title: { display: true, text: "Heart Rate (bpm)" },
        },
      },
    };

    return { chartData, chartOptions };
  },
};
</script>
